

export const blockIcon =  <svg
stroke="currentColor"
fill="currentColor"
strokeWidth="0"
viewBox="0 0 16 16"
height="1em"
width="1em"
xmlns="http://www.w3.org/2000/svg"
>
<path
	fillRule="evenodd"
	d="M13 9H3V8h10v1zm0 3H3v-1h10v1z"
	clipRule="evenodd"
></path>
<path
	fillRule="evenodd"
	d="M5 14V9h1v5H5zm4 0V9h1v5H9z"
	clipRule="evenodd"
></path>
<path d="M4 1h5v1H4a1 1 0 00-1 1v10a1 1 0 001 1h8a1 1 0 001-1V6h1v7a2 2 0 01-2 2H4a2 2 0 01-2-2V3a2 2 0 012-2z"></path>
<path d="M9 4.5V1l5 5h-3.5A1.5 1.5 0 019 4.5z"></path>
</svg>;

export const verticalLineIcon = <svg xmlns='http://www.w3.org/2000/svg' width={24} height={24} viewBox='0 0 14.707 14.707'>
	<rect x='6.275' y='0' width='2.158' height='14.707' />
</svg>;

export const horizontalLineIcon = <svg xmlns='http://www.w3.org/2000/svg' width={24} height={24} viewBox='0 0 357 357'>
	<path d='M357,204H0v-51h357V204z' />
</svg>;